import Flickity from "flickity";
import CrownForm from "./CrownForm";
import Tracking from "./Tracking";
import "./quote-form";

const consentEvt = (e: Event) => {
  const acceptedCategories = (<CustomEvent>e).detail || {};

  if (acceptedCategories?.performance) {
    const tracking = new Tracking();
    tracking.init();
  } else {
    Tracking.clear();
  }
};

window.addEventListener("cf_consent", consentEvt);
window.addEventListener("cf_consent_loaded", consentEvt);

window.addEventListener("touchstart", () => false);

const DOM = {
  body: document.querySelector("body"),
  html: document.querySelector("html"),
  header: document.querySelector("header"),
  nav: document.querySelector("nav"),
  hamburger: document.querySelector(".hamburger"),
};

const sliderDefaults = {
  cellAlign: "center",
  contain: true,
  prevNextButtons: false,
  pageDots: true,
  watchCSS: true,
  autoPlay: false,
};

const URLs = {
  theme: "/wp-content/themes/crownenergy",
  ajax: "/wp-content/themes/crownenergy/ajax",
};

// Add a container around wide tables
const responsiveTables = document.querySelectorAll(".responsive-table");
for (const table of responsiveTables) {
  table.classList.remove("responsive-table");

  const container = document.createElement("div");
  container.classList.add("responsive-table");
  container.style.overflowX = "auto";
  container.innerHTML = table.outerHTML;

  table.replaceWith(container);
}

// Check user has scrolled 80% past hero section to dock header
const headerTrigger = document.querySelector(".headerTrigger");
if (headerTrigger) {
  new IntersectionObserver(
    (entries) => {
      DOM.header?.classList[entries[0].isIntersecting ? "remove" : "add"](
        "scrolled"
      );
    },
    {
      threshold: 0.1, // 10% of 320px = 32px
    }
  ).observe(headerTrigger);
}

// Apply correct colours to header elements based on service selected
document.querySelectorAll(".service-type").forEach((el) => {
  el.addEventListener("click", function (e) {
    e.stopPropagation();

    const serviceFor = (el as HTMLButtonElement).dataset.serviceFor;

    // Remove specific classes from body, and then reapply the correct one
    DOM.body!.classList.remove("for-home", "for-business");
    DOM.body!.classList.add(`for-${serviceFor}`);

    // Animate the SVG tick in the button
    const svgTick = el.querySelector("svg")!;
    svgTick.classList.add("animate");

    setTimeout(() => svgTick.classList.remove("animate"), 2000);

    // Toggle colours of SVG icons in nav
    document
      .querySelectorAll(".social_icon .social_icon--path")
      .forEach((icon) => {
        icon.classList.remove("social_icon--home", "social_icon--business");
        icon.classList.add(`social_icon--${serviceFor}`);
      });

    // Hacky way of opening the Services menu
    DOM.nav?.querySelector(".has-megamenu")?.classList.add("revealed");

    // Update user session
    fetch(`${URLs.ajax}/UpdateService.php`, {
      method: "post",
      body: `service=${serviceFor}`,
      headers: {
        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        "X-Requested-With": "fetch",
      },
    });
  });
});

// Show/hide menu upon clicking hamburger icon
DOM.hamburger?.addEventListener("click", function () {
  document
    .querySelectorAll("nav .revealed")
    .forEach((link) => link.classList.remove("revealed"));

  DOM.html!.classList.toggle("no-overflow");
  [DOM.nav, this].forEach((el) => el.classList.toggle("opened"));
});

// Toggle the megamenus upon clicking a dropdown item in the nav
document.querySelectorAll(".has-megamenu").forEach((link) => {
  link.addEventListener("click", function (e) {
    if ((e.target as HTMLLIElement).classList.contains("nav-link--main")) {
      e.preventDefault();

      link.classList.toggle("revealed");
    }
  });
});

// Close menu straight after clicking a link
const megaMenus = document.querySelectorAll(".megamenu");

megaMenus.forEach((el) => {
  el.addEventListener("click", function (e) {
    if ((e.target as HTMLAnchorElement).tagName === "A") {
      [...megaMenus].forEach((el) =>
        (el.parentNode as HTMLDivElement).classList.remove("revealed")
      );
    }
  });
});

// Image slider on front page
const sliderEl = document.querySelector(".front-slider");
if (sliderEl) {
  const flkty = new Flickity(sliderEl, {
    cellAlign: "center",
    contain: true,
    autoPlay: true,
    prevNextButtons: false,
    pageDots: false,
  });

  document.querySelector("#frontSliderCount")!.textContent =
    flkty.slides.length.toString();

  flkty.on("change", function (i) {
    if (i) {
      document.querySelector("#frontSliderCurrent")!.textContent = (
        (i as unknown as number) + 1
      ).toString();
    }
  });

  document
    .querySelector(".slider-prev")!
    .addEventListener("click", () => flkty.previous(true));

  document
    .querySelector(".slider-next")!
    .addEventListener("click", () => flkty.next(true));
}

// Side Tabs elements
const sideTabs = document.querySelectorAll(".side-tabs");
if (sideTabs.length) {
  sideTabs.forEach((el) => {
    const currentEl = el.querySelector(
      ".side-tabs--links__current"
    ) as HTMLDivElement;
    const tabLinks = [
      ...el.querySelectorAll<HTMLButtonElement>(".side-tabs--links button"),
    ];
    const tabPanes = [
      ...el.querySelectorAll<HTMLDivElement>(".side-tabs--content__pane"),
    ];
    const tabLinksPanel = el.querySelector<HTMLDivElement>(".side-tabs--links");

    tabLinksPanel!.addEventListener("click", (e) => {
      e.preventDefault();

      const clickedTab = e.target as HTMLButtonElement;
      const clickedTabIdx = tabLinks.indexOf(clickedTab);

      if (clickedTab.nodeName.toLowerCase() === "button") {
        [...tabLinks, ...tabPanes].forEach((el) =>
          el.classList.remove("side-tab__selected")
        );
        [clickedTab, tabPanes[clickedTabIdx]].forEach((el) =>
          el.classList.add("side-tab__selected")
        );

        const { clientHeight, offsetTop } = clickedTab;

        currentEl!.style.height = `${clientHeight}px`;
        currentEl!.style.transform = `translateY(${offsetTop}px)`;
      }
    });
  });
}

// Front page project deliverables
if (document.querySelector(".project-deliverables")) {
  new Flickity(".project-deliverables--slider", sliderDefaults);
}

// Front page commitments
if (document.querySelector(".commitments-slider")) {
  new Flickity(".commitments-slider", sliderDefaults);

  const obs = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((el) => {
        if (!el.isIntersecting) {
          return;
        }

        el.target.querySelector("svg")?.classList.add("anim");
        obs.unobserve(el.target);
      });
    },
    {
      threshold: 0.6,
    }
  );

  document
    .querySelectorAll(".commitments-slider .commitment")
    .forEach((el) => obs.observe(el));
}

// Glowing units
const unitsGlow = document.querySelectorAll<HTMLDivElement>(".units-glow");

if (unitsGlow.length) {
  unitsGlow.forEach((unitSection) => {
    const units = unitSection.querySelectorAll<HTMLAnchorElement>(".unit");

    units.forEach((el) => {
      el.addEventListener("mousemove", (e: MouseEvent) => {
        const shadowX =
          e.pageX - el.getBoundingClientRect().left - window.scrollX;
        const shadowY =
          e.pageY - el.getBoundingClientRect().top - window.scrollY;

        el.style.setProperty("--x", `${shadowX}px`);
        el.style.setProperty("--y", `${shadowY}px`);
      });
    });
  });
}

// Collapse elements
const collapseContainers = document.querySelectorAll(".collapse-container");
collapseContainers.forEach((el) => {
  el.addEventListener("click", (e) => {
    e.preventDefault();

    const clickedCta = e.target as HTMLElement;

    if (clickedCta.classList.contains("collapse-cta")) {
      const collapseContent =
        clickedCta.parentNode?.querySelector(".collapse-content");

      if (collapseContent) {
        collapseContent.classList.toggle("collapsed");
      }
    }
  });
});

// Live Chat button on home page
const lcBtn = document.querySelector("a.lets-talk");
if (lcBtn) {
  lcBtn.addEventListener("click", function (e) {
    e.preventDefault();

    // @ts-expect-error
    if (typeof LC_API !== "undefined") {
      // @ts-expect-error
      LC_API.open_chat_window({ source: "button" });
    } else {
      console.error("LiveChat error.");
    }

    return false;
  });
}

// Click to close nav
document.addEventListener("click", function (e) {
  if (!DOM.nav?.contains(e.target as HTMLElement)) {
    const navItemsOpen = DOM.nav?.querySelectorAll("ul.main-nav > li.revealed");

    if (navItemsOpen) {
      Array.from(navItemsOpen).forEach((el) => el.classList.remove("revealed"));
    }
  }
});

// Switch service list on click
const serviceToggle = document.querySelector<HTMLDivElement>(
  ".units-wrapper-buttons--toggle"
);
const serviceLists = document.querySelectorAll(".units-wrapper-buttons .unit");
const serviceSections = document.querySelectorAll(".service-list");

if (serviceToggle) {
  serviceToggle.addEventListener("click", (e: MouseEvent) => {
    e.preventDefault();

    const clickedService = e.target as HTMLElement;

    if (clickedService.classList.contains("unit")) {
      const clickedServiceName = clickedService.dataset.sectionTarget;
      const serviceSection = document.querySelector(
        `.service-list[data-section-name="${clickedServiceName}"]`
      ) as HTMLElement;
      const serviceSectionIdx = [...serviceSections].indexOf(serviceSection);

      [...serviceLists, ...serviceSections].forEach((el) =>
        el.classList.remove("active")
      );
      [clickedService, serviceSection].forEach((el) =>
        el.classList.add("active")
      );

      (
        document.querySelector(".service-lists--track") as HTMLElement
      ).style.transform = `translateX(-${serviceSectionIdx * 100}%)`;
    }
  });
}

// Contact form
const contactForm = document.querySelector<HTMLFormElement>("#contact-form");

if (contactForm) {
  // Submit contact form
  new CrownForm({
    el: contactForm,

    url: "/wp-content/themes/crownenergy/ajax/ContactForm.php",

    success() {
      window.location.href = "/thank-you-contact/";
    },
  });
}

let flameColour = "e30620";

if (
  "matchMedia" in window &&
  window.matchMedia("(prefers-color-scheme: dark)").matches
) {
  flameColour = "ebf7ff";
}

console.log(
  `%cMMMMMMMMMMMMNOdkKNWMMMMMMMMMMMMMMMMMMMMA
MMMMMMMMMMMMWk;,;lxKNWMMMMMMMMMMMMMMMMMM
MMMMMMMMMMMMWk;,,,';cxXWMMMMMMMMMMMMMMMM
MMMMMMMMMMMMNx;',,'..'cONMMMMMMMMMMMMMMM
MMMMMMMMMMMMXo,''''....,dXWMMMMMMMMMMMMM
MMMMMMMMMMMWO:''''''....'cOWMMMMMMMMMMMM
MMMMMMMMMMMXo,''',,'......;xXWMMMMMMMMMM
MMMMMMMMMMWk;'''',,'.......,oKWMMMMMMMMM
MMMMMMMMMW0c'''',;,'..''''.''c0WMMMMMMMM
MMMMMMMMWKl'''',;;'''''''''''':OWMMMMMMM
MMMMMMMMXo,'''';:,'''''''''''',:OWMMMMMM
MMMMMMMXd,'''';:;,,,,,,'..,,,,,,cOWMMMMM
MMMMMMNx,'''';c;,,,,;,,...';;,,,;lKMMMMM
MMMMMM0:'..',::;;;;;;::'..';:;;;;:xNMMMM
MMMMMNx,...':::;;;;:cdx;...;c:;;;:oXMMMM
MMMMMXo'...,:::::::okKO;...,cc::::oXMMMM
MMMMMXl'..';::;;;;lONNk,...,cc;;::xNMMMM
MMMMMNo'..';:;;;;:dXMXo....,c:;;;cOWMMMM
MMMMMWO;...,;;;;;:kNNO;....;:;;;:xNMMMMM
MMMMMMNx,..',,,,,:kOd:....';;,,;dXMMMMMM
MMMMMMMNk;..''',',:;......',,,ckNMMMMMMM
MMMMMMMMW0o,..''''''''...',:lkXWMMMMMMMM
MMNK00Okkxo:'.'''.',:ldddxOKNMMMMMMMMMMM
MWKl,''''''',''''....,ckNWMMMMMMMMMMMMMM
MMW0l'.'''.............,ckNMMMMMMMMMMMMM
MMMMXd,.'''.....,::clloddkXWMMMMMMMMMMMM
MMMMMNk;.','....:lllldOXWMMMMMMMMMMMMMMM
WKkxdoc;..','.........';lkNMMMMMMMMMMMMM
WXOdl;'.................'oXMMMMMMMMMMMMM
MMMMNKko:,..............:0MMMMMMMMMMMMMM
MMMMMMMWNKko;'.........,xWMMMMMMMMMMMMMM
MMMMMMMMMMMWN0xl;'.....oXMMMMMMMMMMMMMMM
MMMMMMMMMMMMMMMWXOdc:,c0WMMMMMMMMMMMMMMM
MMMMMMMMMMMMMMMMMMWWNXXWMMMMMMMMMMMMMMMM
MMMMWWWWWWWWNNNNNNNNNNWWWWWWWWMMMMMMMMMM
RMMMMMWWWWWWWWWWWWWWWWWWWWWWWWMMMMMMMMMK`,
  `color: #${flameColour}; font-size: 10px;`
);
